export const CATEGORIES_BEGIN = 'CATEGORIES_BEGIN';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_ERROR = 'CATEGORIES_ERROR';

export const ITEMS_BEGIN = 'ITEMS_BEGIN';
export const ITEMS_SUCCESS = 'ITEMS_SUCCESS';
export const ITEMS_ERROR = 'ITEMS_ERROR';
export const ITEMS_PER_CATEGORY_BEGIN = 'ITEMS_PER_CATEGORY_BEGIN';
export const ITEMS_PER_CATEGORY_SUCCESS = 'ITEMS_PER_CATEGORY_SUCCESS';
export const ITEMS_PER_CATEGORY_ERROR = 'ITEMS_PER_CATEGORY_ERROR';
export const SINGLE_ITEM_BEGIN = 'SINGLE_ITEM_BEGIN';
export const SINGLE_ITEM_SUCCESS = 'SINGLE_ITEM_SUCCESS';
export const SINGLE_ITEM_ERROR = 'SINGLE_ITEM_ERROR';

export const SET_GRIDVIEW = 'SET_GRIDVIEW';
export const SET_LISTVIEW = 'SET_LISTVIEW';
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';
export const UPDATE_SORT = 'UPDATE_SORT';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_PRICE = 'UPDATE_PRICE';
export const FS_BEGIN = 'FS_BEGIN';
export const FS_SUCCESS = 'FS_SUCCESS';
export const FS_ERROR = 'FS_ERROR';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
